function setFavoritesTotalCardsNumberIntoRelativeButton(){
    const videosNumber = favoritesVideosData.length;
    const eventsNumber = favoritesEventsData.length;
    const trainingsNumber = favoritesTrainingData.length;
    const mountainsNumber = favoritesMountainsData.length;
    const teamsNumber = favoritesTeamsData.length;
    const playlistsNumber = favoritesPlaylistsData.length;

    const videoConstants = {
        videos: videosNumber,
        events: eventsNumber,
        trainings: trainingsNumber,
        mountains: mountainsNumber,
        teams: teamsNumber,
        playlists: playlistsNumber
    }

    const namesArray = ['videos', 'events', 'trainings', 'mountains', 'teams', 'playlists'];

    namesArray.map(item => $(`.js-favorites-number-of-${item}`).text(`(${videoConstants[item]})`));
}

runIfElementExist(setFavoritesTotalCardsNumberIntoRelativeButton, '.js-favorites-number-of-videos');
